module.exports = __webpack_public_path__ + "assets/round-checkbox-off.d274a683.svg";